import { useEffect } from 'react';
import { toast } from 'sonner';
import { useLanguage } from '@/contexts/LanguageContext';

const SHOWN_KEY = 'wakacasa.langToastShown';

/**
 * First-visit language hint. If the visitor has never picked a language
 * (localStorage.lang is unset) we show a one-time sonner toast inviting
 * them to switch to English. Auto-dismisses after 8 s; a "✕" close button
 * marks the toast as seen even if they don't interact.
 *
 * Lives BELOW the LanguageProvider so `setLanguage` is available.
 */
export default function FirstVisitLanguageToast() {
  const { language, setLanguage } = useLanguage();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const hasExplicitChoice = !!localStorage.getItem('lang');
    const alreadyShown = localStorage.getItem(SHOWN_KEY) === '1';
    if (hasExplicitChoice || alreadyShown) return;
    if (language !== 'es') return; // only relevant when ES default is active

    const markShown = () => localStorage.setItem(SHOWN_KEY, '1');

    // Small delay so it doesn't fight with the page's first paint
    const timer = setTimeout(() => {
      toast(
        '🇻🇪 Mostrando en Español',
        {
          description: 'Showing in Spanish — switch to English?',
          duration: 8000,
          action: {
            label: 'Switch to English',
            onClick: () => {
              setLanguage('en');
              markShown();
            },
          },
          onDismiss: markShown,
          onAutoClose: markShown,
        }
      );
    }, 900);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
